import { ApiModule } from '@common/index';
import type { UserStat } from '../models';

export class DashboardApi extends ApiModule {
  public loadUserStat() {
    return this.api.get<UserStat>('/base/stat');
  }
}
